<div class="annual-container">
  <div class="annual-header">
    <app-page-title
      header="Annual Statement"
      iconClass="ic-documents-20"
    />

    <div class="actions-container">
      <div class="btn-container">
        <app-button
          text="Close"
          btnColor="white"
          (clickBtn)="close()"
        />
        @if (currentStepIndex === AnnualStep.SignDocuments) {
          <app-divider [vertical]="true"/>

          @if (showSendEmailBtn()) {
            <!-- Sign via email -->
            <app-button
              iconClassLast="icon ic-arrow-right-20"
              text="Send email"
              [loading]="loading || isLoading()"
              [isDisabled]="loading || isLoading() || disabledHeaderBtn()"
              (clickBtn)="onSendEmail()"
            />
          } @else if (showSendPaperBtn() && annual.documentSigning?.signingStatus != SigningStatus.Signed) {
            <!-- Paper Sign -->
            <app-button
              iconClassLast="icon ic-arrow-right-20"
              text="Confirm Signing"
              [loading]="loading || isLoading()"
              [isDisabled]="loading || isLoading() || disabledHeaderBtn()"
              (clickBtn)="onPaperSign()"
            />
          } @else if (!showVoidEnvelope()) {
            <!-- Send for eSign -->
            <app-sign-integrations-dropdown
              [outerLoading]="loading || isLoading()"
              [isDisabled]="loading || isLoading() || disabledHeaderBtn()"
              [currentProviderConnectionStatus]="currentProviderConnectionStatus"
              (eSignConnectionChanged)="loadESignProvidersStatus()"
              (send)="onSendForESign()"
            />
          }

        } @else if (currentStepIndex !== AnnualStep.SignDocuments) {
          <app-divider [vertical]="true"/>

          <app-button
            text="Next Step"
            iconClassLast="icon ic-arrow-right-20"
            [loading]="loading || isLoading()"
            [isDisabled]="loading || isLoading() || disabledHeaderBtn()"
            (clickBtn)="confirmChanges()"
          />
        }
      </div>
    </div>
  </div>

  <div class="annual-content" [class.hide]="collapsedStateBtn">
    <app-annual-statement-sidebar
      [class.hide]="collapsedStateBtn"
      [loadCompany]="loading"
      [currentStepIndex]="currentStepIndex"
      [annualStatement]="annual"
      [entity]="actualCompany || actualTrustProfile"
      [entityType]="entityType"
      (updateAnnualStatement)="updateAnnual()"
    />

    <div class="step-content">
      <app-button
        class="sidebar-switch-btn"
        btnColor="white"
        [iconClass]="collapsedStateBtn ? 'icon ic-arrow-right-20' : 'icon ic-arrow-left-20'"
        (clickBtn)="collapsedStateBtn = !collapsedStateBtn"
      />

      <div class="d-flex flex-column w-100">
        @if (!loading) {
          <app-clickable-stepper
            class="stepper-container"
            [currentStepIndex]="currentStepIndex"
            [steps]="steps"
            [disableSteps]="modalOpened() || isLoading()"
            (stepIndexChange)="trySetCurrentStep($event)"
          />
        }

        <div class="content-container" [class.sign-container]="currentStepIndex === AnnualStep.SignDocuments">
          @switch (currentStepIndex) {
            @case (AnnualStep.Authorisation) {
              @if (!loading && annual && actualCompany) {
                <app-annual-statement-authorization
                  [annual]="annual"
                  [company]="actualCompany"
                  [confirmAction$]="confirmAction$"
                  (nextStep)="setNextStep()"
                />
              } @else if (loading) {
                <div class="sign-container" [ngTemplateOutlet]="skeletonTemplate"></div>
              } @else {
                <div></div>
              }
            }
            @case (AnnualStep.GenerateDocuments) {
              @if (!loading && annual && actualCompany) {
                <app-annual-generate-documents
                  [annual]="annual"
                  [company]="actualCompany"
                  [confirmAction$]="confirmAction$"
                  [isSubmitting]="loading || isLoading()"
                  (generateAnnualStatementE)="tryGenerateAnnualStatement($event)"
                />
              } @else if (loading) {
                <div class="sign-container" [ngTemplateOutlet]="skeletonTemplate"></div>
              } @else {
                <div></div>
              }
            }
            @case (AnnualStep.SignDocuments) {
              @if (!loading && annual) {
                <app-annual-sign-documents
                  [documentBase]="annual"
                  [annualStatementStatus]="annual.annualStatementStatus"
                  [confirmAction$]="confirmAction$"
                  [confirmSentESignAction$]="confirmSentESignAction$"
                  [confirmSendEmailAction$]="confirmSendEmailAction$"
                  [confirmPaperSignAction$]="confirmPaperSignAction$"
                  [selectedESignConnection]="currentProviderConnectionStatus?.connectionType ?? null"
                  (refreshSignEntity$)="refreshAnnualStatement()"
                  (reloadDocument)="reloadAnnualStatement()"
                  (nextStep)="setNextStep()"
                />
              } @else if (loading) {
                <div class="sign-container" [ngTemplateOutlet]="skeletonTemplate"></div>
              } @else {
                <div></div>
              }
            }
            @default {
              <p>Unexpected step index: {{ currentStepIndex }}</p>
            }
          }
        </div>
      </div>
    </div>
  </div>
</div>

<ng-template #skeletonTemplate>
  <div class="skeleton-container">
    <div class="mb-4">
      <ngx-skeleton-loader count="1" appearance="line"/>
    </div>
    <ngx-skeleton-loader count="1" appearance="line"/>
    <ngx-skeleton-loader count="2" appearance="line"/>
    <div class="d-flex gap-24">
      <ngx-skeleton-loader style="width: 50%" count="1" appearance="line"/>
      <ngx-skeleton-loader style="width: 50%" count="1" appearance="line"/>
    </div>
    <ngx-skeleton-loader count="2" appearance="line"/>
    <div class="d-flex gap-24">
      <ngx-skeleton-loader style="width: 50%" count="1" appearance="line"/>
      <ngx-skeleton-loader style="width: 50%" count="1" appearance="line"/>
    </div>
    <ngx-skeleton-loader count="6" appearance="line"/>
  </div>
</ng-template>
